module.exports = __webpack_public_path__ + "static/media/home_bg_lg.28215e4d.gif";